__turbopack_context__.v({
  "chipsScroll": "-0Jy2q_chipsScroll",
  "dividerLight": "-0Jy2q_dividerLight",
  "empty": "-0Jy2q_empty",
  "feedLabel": "-0Jy2q_feedLabel",
  "filterChip": "-0Jy2q_filterChip",
  "highlight": "-0Jy2q_highlight",
  "iconCell": "-0Jy2q_iconCell",
  "itemBody": "-0Jy2q_itemBody",
  "itemBtn": "-0Jy2q_itemBtn",
  "itemContent": "-0Jy2q_itemContent",
  "itemContentCompact": "-0Jy2q_itemContentCompact",
  "itemSelected": "-0Jy2q_itemSelected",
  "itemTitle": "-0Jy2q_itemTitle",
  "itemTitleRow": "-0Jy2q_itemTitleRow",
  "itemsList": "-0Jy2q_itemsList",
  "kbdChip": "-0Jy2q_kbdChip",
  "keyboardHintLabel": "-0Jy2q_keyboardHintLabel",
  "keyboardHints": "-0Jy2q_keyboardHints",
  "loadingPad": "-0Jy2q_loadingPad",
  "metaBullet": "-0Jy2q_metaBullet",
  "metaTag": "-0Jy2q_metaTag",
  "mobileHandle": "-0Jy2q_mobileHandle",
  "mobileHandleWrap": "-0Jy2q_mobileHandleWrap",
  "overlay": "-0Jy2q_overlay",
  "packageBadge": "-0Jy2q_packageBadge",
  "panel": "-0Jy2q_panel",
  "portalRoot": "-0Jy2q_portalRoot",
  "resultsSection": "-0Jy2q_resultsSection",
  "rowIconSvg": "-0Jy2q_rowIconSvg",
  "rowIconWrap": "-0Jy2q_rowIconWrap",
  "scrollArea": "-0Jy2q_scrollArea",
  "searchBarContainer": "-0Jy2q_searchBarContainer",
  "searchDismiss": "-0Jy2q_searchDismiss",
  "searchInput": "-0Jy2q_searchInput",
  "searchModalDesktopIn": "-0Jy2q_searchModalDesktopIn",
  "searchModalDesktopOut": "-0Jy2q_searchModalDesktopOut",
  "searchModalOverlayIn": "-0Jy2q_searchModalOverlayIn",
  "searchModalOverlayOut": "-0Jy2q_searchModalOverlayOut",
  "searchModalSheetIn": "-0Jy2q_searchModalSheetIn",
  "searchModalSheetOut": "-0Jy2q_searchModalSheetOut",
  "searchRow": "-0Jy2q_searchRow",
  "sectionHeading": "-0Jy2q_sectionHeading",
  "shortDesc": "-0Jy2q_shortDesc",
  "statusDot": "-0Jy2q_statusDot",
  "statusGroup": "-0Jy2q_statusGroup",
  "statusLabel": "-0Jy2q_statusLabel",
  "statusMeta": "-0Jy2q_statusMeta",
  "stickyFooter": "-0Jy2q_stickyFooter",
  "stickyHead": "-0Jy2q_stickyHead",
  "titleTag": "-0Jy2q_titleTag",
  "visuallyHidden": "-0Jy2q_visuallyHidden",
});
